import React from 'react';

import {
  TextField,
} from '@mui/material';
import { Controller } from 'react-hook-form';

/**
 * プロパティ
 */
export type Props = {
  /** 名前 */
  name: string,
  /** ラベル */
  label: string,
  /** ルール */
  rules: any,
  /** エラー */
  errors: any,
  /** コントロール */
  control: any,
}

const TimeFieldComp: React.FC<Props> = ({
  control,
  rules,
  name,
  label,
  errors,
}) => (
  <div style={{ margin: '10px 0' }}>
    <Controller
      render={
        ({ field }) => (
          <TextField
            label={label}
            variant="outlined"
            value={field.value}
            onChange={field.onChange}
            type="time"
            fullWidth
            error={errors[name] !== undefined}
            helperText={errors[name] && errors[name].message}
          />
        )
      }
      name={name}
      control={control}
      rules={rules}
    />
  </div>
);

export default TimeFieldComp;
